<div class="modal-backdrop" (click)="this.dialogRef.close()"></div>
<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">Adicionar Profissão</h3>
    </div>

    <div class="modal-body">
      @if(professionForm){
      <form [formGroup]="professionForm">
        <div formGroupName="professionInfo">
          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>Profissão</mat-label>
            <mat-select formControlName="professionName">
              @for(profession of getProfessionName(); track profession){
              <mat-option [value]="profession">{{ profession }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>Especialidade</mat-label>
            <mat-select formControlName="specialty" (selectionChange)="onSpecialtyChange()">
              @for(specialty of getSpecialty(); track specialty){
              <mat-option [value]="specialty">{{ specialty }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>RQE da Especialidade</mat-label>
            <input matInput formControlName="specialtyRQE" />
          </mat-form-field>
          
          @if(showActivityAreas){
          <div formArrayName="activityAreas">
            <div style="max-height: 300px; overflow-y: auto; overflow-x: clip">
              <div *ngFor="let area of getActivityArea(); let i = index" [formGroupName]="i">
                <div style="display: flex; align-items: baseline; justify-content: space-between; margin-top: 10px;">
                  @if(area != null && area != ''){
                  <mat-checkbox [checked]="activityAreas.at(i).get('activityArea').value === area"
                    (change)="onAreaCheckboxChange($event, i, area!)" style="flex: 1;">{{ area }}</mat-checkbox>

                  <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic"
                    style="flex: 0 100px">
                    <mat-label>RQE da Área</mat-label>
                    <input matInput formControlName="activityAreaRQE" />
                  </mat-form-field>
                  }
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </form>
      }
    </div>

    <div class="modal-footer">
      <button mat-raised-button class="btn btn-ghost" (click)="this.dialogRef.close()">
        Voltar sem alterar
      </button>
      <button mat-flat-button class="btn btn-primary" (click)="addProfession()" [disabled]="!professionForm.valid">
        Adicionar
      </button>
    </div>
  </div>
</div>